import type { POI } from "@poi-planner/shared";

export function hasUsableCoordinates(
  poi: POI,
): poi is POI & { lat: number; lng: number } {
  return (
    poi.lat != null &&
    poi.lng != null &&
    Number.isFinite(poi.lat) &&
    Number.isFinite(poi.lng)
  );
}

/** Resolve a linked note location using end-first travel semantics. */
export function resolveNoteMapPoi(
  startPoi: POI | null | undefined,
  endPoi: POI | null | undefined,
): POI | null {
  if (endPoi && hasUsableCoordinates(endPoi)) return endPoi;
  if (startPoi && hasUsableCoordinates(startPoi)) return startPoi;
  return null;
}

/**
 * Map membership is the union of Planner context and the Sidebar's filtered
 * set. Planner entries intentionally win when both surfaces include a place.
 * Keep the first occurrence so a place
 * scheduled more than once still produces one marker.
 */
export function mergePlannerMapPois(
  visibleSidebarPois: POI[],
  plannerPois: Array<POI | null | undefined>,
): POI[] {
  const seen = new Set<string>();
  const result: POI[] = [];

  for (const poi of [...plannerPois, ...visibleSidebarPois]) {
    if (!poi || seen.has(poi.id) || !hasUsableCoordinates(poi)) continue;
    seen.add(poi.id);
    result.push(poi);
  }

  return result;
}

/** @deprecated Use mergePlannerMapPois; retained for focused legacy tests. */
export const mergeDayMapPois = mergePlannerMapPois;
